export const selectProducers = state => state.producer.producers
export const selectProvider = state => state.producer.provider
export const selectAllProviders = state =>
  state.producer.providers?.providers.map(p => {
    return { ...p, value: p.id, label: p.name }
  })
export const selectHistoryProvider = state => state.producer.history
export const selectAllProvidersPaginated = state => state.producer.providers
